import { StandardEvents } from '@shopify/events';

class MetBandSelectedDetails extends HTMLElement {
  #section;
  #sequence = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
    this.#section = undefined;
    this.#sequence += 1;
  }

  #setUnavailable = () => {
    const content = this.querySelector('[data-band-content]');
    content?.replaceChildren();
    if (content) content.hidden = true;
    const status = this.querySelector('[data-band-status]');
    if (status) {
      status.textContent = this.dataset.unavailableLabel || '';
      status.hidden = false;
    }
    this.dataset.variantId = '';
    this.dataset.sourceSku = '';
    this.dataset.detailsValid = 'false';
    this.removeAttribute('aria-busy');
  };

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;
    const picker = event.target.closest('variant-picker');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    const owner = this.closest('product-component');
    if (owner && event.target.closest('product-component') !== owner) return;
    const sequence = ++this.#sequence;
    this.#setUnavailable();
    this.setAttribute('aria-busy', 'true');
    const status = this.querySelector('[data-band-status]');
    if (status) status.textContent = this.dataset.loadingLabel || '';
    Promise.resolve(event.promise).then((result) => {
      if (!this.isConnected || sequence !== this.#sequence) return;
      const detail = result?.detail;
      if (!detail?.html || String(detail.productId) !== this.dataset.productId || !detail.resource?.id) {
        this.#setUnavailable();
        return;
      }
      const incoming = Array.from(detail.html.querySelectorAll('met-band-selected-details')).find((candidate) =>
        candidate.dataset.productId === this.dataset.productId && candidate.dataset.blockId === this.dataset.blockId
      );
      if (!incoming || incoming.dataset.detailsValid !== 'true' || incoming.dataset.variantId !== String(detail.resource.id)) {
        this.#setUnavailable();
        return;
      }
      const nextContent = incoming.querySelector('[data-band-content]');
      const content = this.querySelector('[data-band-content]');
      if (!nextContent || !content) {
        this.#setUnavailable();
        return;
      }
      content.replaceWith(nextContent.cloneNode(true));
      this.dataset.variantId = incoming.dataset.variantId;
      this.dataset.sourceSku = incoming.dataset.sourceSku;
      this.dataset.detailsValid = 'true';
      const status = this.querySelector('[data-band-status]');
      if (status) {
        status.textContent = '';
        status.hidden = true;
      }
      this.removeAttribute('aria-busy');
    }).catch(() => {
      if (this.isConnected && sequence === this.#sequence) this.#setUnavailable();
    });
  };
}

if (!customElements.get('met-band-selected-details')) {
  customElements.define('met-band-selected-details', MetBandSelectedDetails);
}
